import type {
  LocaleString,
  LocaleText,
  Story,
} from '@/.generated/sanityTypes/graphql'
import Img from '@/components/Img'
import withNewLines from '@/lib/withNewLines'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useRouter } from 'next/router'

type StoryCardProps = {
  story: Story
}

const StoryCard = ({ story }: StoryCardProps) => {
  const { locale = 'de' } = useRouter()
  const t = useTranslations('stories')

  if (!story.slug) {
    return <div>Error - no slug</div>
  }

  return (
    <Link
      href={`/stories/${story.slug.current}`}
      className="tbf-hover relative flex flex-col bg-white text-center"
    >
      {/* IMAGE */}
      {story.image?.asset?.url && (
        <Img
          sizes="(min-width: 1360px) 620px, (min-width: 780px) 44.64vw, 100vw"
          image={story.image}
          objectFit="cover"
          alt={story?.title?.[locale as keyof LocaleString] || ''}
          style={{
            height: 270,
          }}
        />
      )}

      {/* YEAR TAG */}
      {story.yearTag && (
        <span className="absolute right-5 top-5 bg-yellow-500 px-12 py-2">
          {story.yearTag?.[locale as keyof LocaleString]}
        </span>
      )}

      {/* CONTENT */}
      <div className="relative z-10 m-6 -mt-16 mb-0 bg-white p-4 text-center">
        {story.title?.[locale as keyof LocaleText] && (
          <h3 className="mx-auto mb-1 mt-0 w-2/3 text-3xl leading-none text-red-500">
            {withNewLines(story.title?.[locale as keyof LocaleText])}
          </h3>
        )}
        {story.subtitle?.[locale as keyof LocaleText] && (
          <h4 className="mb-3 text-xl font-medium leading-none">
            {story.subtitle?.[locale as keyof LocaleText]}
          </h4>
        )}

        <div className="text-lg leading-tight">
          {story.excerpt?.[locale as keyof LocaleText]}
        </div>

        <div className="pt-3 text-lg text-gray-500">
          {t('more')}
          {' →'}
        </div>
      </div>
    </Link>
  )
}

export default StoryCard
